<template>
  <form class="form-inline remark" style="margin-left: 0;">
    <b-container style="margin-left: 0;">
      <b-row v-if="!inTable" align-v="center">
        <b-col cols="2" style="padding-left: 0;">
          <label class="text-left" style="justify-content: start;" for="remark"
            >File Upload :</label
          >
        </b-col>
        <b-col cols="10" class="text-left">
          <file-upload
            v-model="fileUploadComputed"
            :multiple="true"
            :input-id="`${itemIndex}`"
            :size="1024 * 1024 * 2"
            :extensions="['jpg', 'pdf', 'png', 'jpeg']"
            @input-file="inputFile"
            @input-filter="inputFilter"
          >
            <b-button class="btn-block">
              Browse
            </b-button>
          </file-upload>
        </b-col>
      </b-row>
      <b-row v-else align-v="center">
        <b-col cols="auto" class="text-left">
          <file-upload
            v-model="fileUploadComputed"
            :multiple="true"
            :input-id="`${itemIndex}`"
            :size="1024 * 1024 * 2"
            :extensions="['jpg', 'pdf', 'png', 'jpeg']"
            @input-file="inputFile"
            @input-filter="inputFilter"
          >
            <b-button class="btn-block">
              Browse
            </b-button>
          </file-upload>
        </b-col>
      </b-row>
      <b-row class="">
        <b-col
          v-for="(file, index) in fileUploadComputed"
          :key="index"
          class="col-auto"
        >
          <span>{{ file.name }} </span>
          <fa-icon
            :icon="['fas', 'times']"
            class="icon"
            @click="delFileHandler(index)"
          />
        </b-col>
      </b-row>
    </b-container>
  </form>
</template>

<script>
import VueUploadComponent from "vue-upload-component";
import Swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "FileUploadComponent",
  components: {
    FileUpload: VueUploadComponent,
  },
  props: {
    fileUpload: {
      required: true,
    },
    itemIndex: {
      required: true,
    },
    inTable: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      items: "Result/getResult",
    }),
    fileUploadComputed: {
      get() {
        return this.fileUpload;
      },
      set(value) {
        this.$emit("update:fileUpload", value);
      },
    },
  },
  mounted() {
    // if (this.items[this.itemIndex].title === 'Test Kit') {
    //   this.fileUploadComputed = this.items[this.itemIndex].result[0].files
    // } else {
    //   this.fileUploadComputed = this.items[this.itemIndex].files
    // }
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      deleteFile: "Result/deleteFileUpload",
    }),
    async inputFile(newFile, oldFile) {
      if (newFile) {
        const fileBase = await this.getBlobFile(newFile.blob);
        newFile.fileBase = fileBase;
        if (newFile && oldFile && !newFile.active && oldFile.active) {
          // Get response data
          if (newFile.xhr) {
            //  Get the response status code
          }
        }
      }
    },
    inputFilter: function(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpeg|jpe|jpg|gif|png|webp|pdf)$/i.test(newFile.name)) {
          return prevent();
        }
        if (newFile.size > 1024 * 1024 * 2) {
          Swal.fire(
            "ผิดพลาด!",
            "ไฟล์ที่อัพโหลดต้องมีขนาดต่ำกว่า 2 MB",
            "error"
          );
          return prevent();
        }
      }

      // Create a blob field
      newFile.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }

      newFile.isFile = true;
    },
    delFileHandler(index) {
      Swal.fire({
        title: "Are you sure?",
        text: "Are you sure you want to delete",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          if (this.fileUploadComputed[index].isFile) {
            return new Promise((resolve) => resolve(true));
          } else {
            return this.deleteFile(this.fileUploadComputed[index].id);
          }
        },
      }).then((result) => {
        if (result.value) {
          this.fileUploadComputed = this.fileUploadComputed.filter(
            (file, key) => key !== index
          );
          Swal.fire("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },
    getBlobFile(blob) {
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.responseType = "blob";

        xhr.onload = function() {
          let recoveredBlob = xhr.response;

          let reader = new FileReader();

          reader.onload = function() {
            resolve(reader.result);
          };

          reader.readAsDataURL(recoveredBlob);
        };

        xhr.open("GET", blob);
        xhr.send();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
